import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { ParametrosMaestro } from 'src/app/models/common/enumModel';
import { ITipoEmpleadoModel } from 'src/app/models/interfaces/tipo-empleado/ITipoEmpleadoModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { TipoEmpleadoModel } from 'src/app/models/tipo-empleado/TipoEmpleadoModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { TipoEmpleadoService } from 'src/app/services/tipo-empleado/tipo-empleado.service';

@Component({
  templateUrl: './configuracion-tipo-empleado-registrar.component.html',
  styleUrls: ['./configuracion-tipo-empleado-registrar.component.css']
})
export class ConfiguracionTipoEmpleadoRegistrarComponent implements OnInit {
  model: ITipoEmpleadoModel = new TipoEmpleadoModel();
  listaEstados: ParametroModel[] = new Array<ParametroModel>();

  constructor(
    private router: Router,
    private gbuService: TipoEmpleadoService,
    private serviceParametros: ParametroService,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
  ) { }

  ngOnInit(): void {
    this.serviceParametros.getDetalles(ParametrosMaestro.ESTADO_CONFIG_MAESTRO).subscribe((data) => {
      this.listaEstados = data.items;
    });
  }

  onSubmit(form: NgForm) {
    if (!form.invalid) {   
      this.confirmDialogService.open('¿Deseas guardar los cambios?'); //options
      this.confirmDialogService.confirmed().subscribe((confirmed) => {
        if (confirmed) {
          this.gbuService.submit(this.model).subscribe((data) => {
            this.alertDialogService.open("El tipo de empleado fue registrado");
            this.router.navigate(['/configuracion', 'tipo-empleados']);  
          });
        }
      });
    }
  }

}
